import BrowseMapButton from './BrowseMapButton';

export default BrowseMapButton;
